import React from 'react';
import { Route, Switch,  BrowserRouter as Router } from 'react-router-dom';
import { ManageAuthRoutes } from './authRoutes';
import ObjectivePage from '../components/ObjectivePage';
import GroupObjectivePage from '../components/GroupObjectivePage';
import InjectAxiosInterceptors from '../config/InjectAxiosInterceptors';
import { ObjectivesDrawerIcon, ProjectsDrawerIcon } from '../assets/icons';
import { Group, Note } from '@material-ui/icons';
import {
  Login,
  Registration,
  ForgottenPassword,
  ChangePassword,
  UserMainPage,
  ProjectsPage,
  SettingsPage,
  ManagerialDecisionsPage,
  MissingLicenceWarning
} from './pages';

export const navigationRoutes = [
  {
    path: '/objectives',
    translationKey: 'common.header.objectives',
    icon: <ObjectivesDrawerIcon/>,
    badgeInfoKey: 'proposedEmployeeObjectives',
    badgeColor: 'error'
  },
  {
    path: '/groupObjectives',
    translationKey: 'common.header.groupObjectives',
    icon: <Group/>,
    badgeInfoKey: 'activeGroupObjectives',
    badgeClassName: 'groupBadge'
  },
  {
    path: '/projects',
    translationKey: 'common.header.projects',
    icon: <ProjectsDrawerIcon/>,
    badgeInfoKey: 'runningProjects',
    badgeColor: 'error'
  },
  {
    path: '/managerialDecisions',
    translationKey: 'common.header.managerialDecisions',
    icon: <Note/>,
    badgeInfoKey: 'notApprovedManagerialDecisions',
    badgeColor: 'error'
  }
];

export const createUserMenuRoutes = handleLogOut => ([
  {
    path: '/settings',
    translationKey: 'common.header.settings',
    icon: <ObjectivesDrawerIcon/>
  },
  {
    path: '/',
    translationKey: 'common.header.logout',
    onClick: handleLogOut,
    icon: <Group/>
  }
]);

export const routes = [
  {
    path: '/',
    key: 'root',
    exact: true,
    noneauth: true,
    licenced: false,
    component: Login
  },
  {
    path: '/registration/:hash',
    key: 'registration',
    exact: true,
    noneauth: true,
    licenced: false,
    component: Registration
  },
  {
    path: '/forgottenPassword',
    key: 'forgottenPassword',
    exact: true,
    noneauth: true,
    licenced: false,
    component: ForgottenPassword
  },
  {
    path: '/changePassword/:hash',
    key: 'changePassword',
    exact: true,
    noneauth: true,
    licenced: false,
    component: ChangePassword
  },
  {
    path: '/objectives',
    key: 'objectives',
    exact: true,
    auth: true,
    licenced: true,
    component: UserMainPage
  },
  {
    path: '/groupObjectives',
    key: 'groupObjectives',
    exact: true,
    auth: true,
    licenced: true,
    component: GroupObjectivePage
  },
  {
    path: '/objective/:objectiveId',
    key: 'objective',
    exact: true,
    auth: true,
    licenced: true,
    component: ObjectivePage
  },
  {
    path: '/projects',
    key: 'projects',
    exact: true,
    auth: true,
    licenced: false,
    component: ProjectsPage
  },
  {
    path: '/settings',
    key: 'settings',
    exact: true,
    auth: true,
    licenced: false,
    component: SettingsPage
  },
  {
    path: '/managerialDecisions',
    key: 'managerialDecisions',
    exact: true,
    auth: true,
    licenced: false,
    component: ManagerialDecisionsPage
  },
  {
    path: '/missing-licence',
    key: 'missing-licence',
    exact: true,
    auth: true,
    licenced: false,
    component: MissingLicenceWarning
  }
];

export function RenderRoutes({ routes }) {
  return (
    <Router>
      <InjectAxiosInterceptors/>
      <Switch>
        {routes.map((route, i) =>
          <ManageAuthRoutes key={ route.key } { ...route } auth={ route.auth }/>
        )}
        <Route component={ () => <h1>Not Found!</h1> } />
      </Switch>
    </Router>
  );
}
